var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 21.3542H7C4 21.3542 2 19.7917 2 16.1458V8.85416C2 5.20833 4 3.64583 7 3.64583H17C20 3.64583 22 5.20833 22 8.85416V16.1458C22 19.7917 20 21.3542 17 21.3542Z","stroke":"#0A9E50","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M17 9.375L13.87 11.9792C12.84 12.8333 11.15 12.8333 10.12 11.9792L7 9.375","stroke":"#0A9E50","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

MailInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = MailInline;

MailInline.default = MailInline;
